import React, { Component } from 'react'
import Translation from './Translation'
import Button from './Button'
import FloatingAlert from '../alerts/FloatingAlert'
import {v4 as uuidv4} from "uuid";

const FILE_LIMIT_SIZE = 10 * 1024 * 1024 // 10 MB in bytes
const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
const ALLOWED_EXTENSIONS = ['dwg', 'dxf', 'eml', 'msg']

class FileInput extends Component {

    state = {
        fileSizeError: false,
        fileTypeError: false,
        uploadedFiles: []
    }

    elementId = undefined
    constructor(props) {
        super(props)
        this.inputRef = React.createRef()
        this.elementId = 'fileInput_' + uuidv4()
    }

    handleFileChange = event => {
        const files = Array.from(event.target.files)
        const validFiles = []
        let fileTooLarge = false
        let fileTypeNotAllowed = false

        console.log('FILES', files)

        files.forEach(file => {
            if (file.size > FILE_LIMIT_SIZE) {
                fileTooLarge = true
            } else if (!(ALLOWED_FILE_TYPES.includes(file.type) || ALLOWED_EXTENSIONS.includes(file.name.split('.').pop().toLowerCase()))) {
                fileTypeNotAllowed = true
            } else {
                validFiles.push(file)
            }
        })

        this.setState({fileSizeError: fileTooLarge})
        this.setState({fileTypeError: fileTypeNotAllowed})

        if (!fileTooLarge && !fileTypeNotAllowed) {
            this.setState({uploadedFiles: [...this.state.uploadedFiles, ...validFiles]})
            this.props.onChange(validFiles)
        }
    }

    handleDeleteFile = index => {
        this.setState({uploadedFiles: [...this.state.uploadedFiles.filter((_, i) => i !== index)]})
        this.props.onChange(null)
    }

    render() {

        return (
            <div className="w-100">
                {
                    this.state.uploadedFiles.length === 0 &&
                    <React.Fragment>
                        <input type="file"
                               onChange={this.handleFileChange}
                               id={this.elementId}
                               style={{ display: 'none' }}
                        />
                        <Button
                            className={this.props.className}
                            onClick={() => document.getElementById(this.elementId).click()}
                        >
                            {this.props.children}
                        </Button>
                    </React.Fragment>
                }

                {this.state.fileSizeError && (
                    <FloatingAlert
                        warningMessage={
                            <Translation id="exceed_file_limit"
                                         defaultMessage={`The file has a limit of {fileLimit} MB`}
                                         values={{ fileLimit: FILE_LIMIT_SIZE / (1024 * 1024) }} // Convert to MB
                            />
                        }
                        onClose={() => this.setState({fileSizeError: false})}
                    />
                )}

                {this.state.fileTypeError && (
                    <FloatingAlert
                        warningMessage={
                            <Translation
                                id="invalid_file_type"
                                defaultMessage="This file type is not allowed."
                            />
                        }
                        onClose={() => this.setState({fileTypeError: false})}
                    />
                )}

                {/* Display the list of uploaded files */}
                <div className="uploaded-files-list">
                    {this.state.uploadedFiles &&
                        this.state.uploadedFiles.map((file, index) => (
                            <div key={index} style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                                <div style={{fontSize:'14px'}}>
                                    <span>{file.name}</span>
                                    <span>&nbsp;&nbsp;{Math.round(file.size/1024)} kb</span>
                                </div>
                                <i className="fal fa-trash" style={{cursor: 'pointer'}}
                                   onClick={() => this.handleDeleteFile(index)}
                                />
                            </div>
                        ))}
                </div>
            </div>
        )
    }
}

export default FileInput
